import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { useStaff, Loading } from "../StaffAuth";
import { Field } from "../ui";

export default function Login() {
  const { staff, loading, error, signIn } = useStaff();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  if (staff) return <Navigate to={staff.must_reset_password ? "/staff/reset-password" : "/staff/overview"} replace />;
  if (loading && !email) return <Loading />;
  const submit = (e) => { e.preventDefault(); signIn(email.trim(), password); };
  return (
    <div className="staff-root grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden border-r border-[var(--s-line)] p-14 lg:flex lg:flex-col lg:justify-between">
        <div className="s-grid absolute inset-0 opacity-60" />
        <p className="s-mono relative text-xs uppercase tracking-[0.3em] text-[var(--s-accent)]">Internal · Invite only</p>
        <h1 className="s-display relative max-w-lg text-5xl leading-[1.05] lg:text-6xl">Staff &amp; Moderation Workspace</h1>
        <p className="relative max-w-sm text-sm text-[var(--s-dim)]">Every action taken here is written to an immutable audit trail.</p>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 s-rise" data-testid="staff-login-form">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--s-accent)] text-black"><Lock size={18} /></div>
          <div>
            <h2 className="s-display text-2xl">Staff sign in</h2>
            <p className="mt-1 text-sm text-[var(--s-dim)]">Use the credentials issued by your administrator.</p>
          </div>
          <Field label="Email"><Input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="s-input" data-testid="staff-login-email" /></Field>
          <Field label="Password"><Input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="s-input" data-testid="staff-login-password" /></Field>
          {error && <p role="alert" className="rounded-lg border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="staff-login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="s-btn w-full" data-testid="staff-login-submit">{loading ? "Verifying…" : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
